"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TiersMode = exports.BillingSchema = void 0;
let BillingSchema = exports.BillingSchema = /*#__PURE__*/function (BillingSchema) {
  BillingSchema["PER_UNIT"] = "per_unit";
  BillingSchema["TIERED"] = "tiered";
  return BillingSchema;
}({});
let TiersMode = exports.TiersMode = /*#__PURE__*/function (TiersMode) {
  TiersMode["GRADUATED"] = "graduated";
  TiersMode["VOLUME"] = "volume";
  return TiersMode;
}({});